const QUESTION_STATUSES = {
  ANSWERED: 'answered',
  DRAFT: 'draft',
  UNANSWERED: 'unanswered',
};

export default QUESTION_STATUSES;
